<app-header></app-header>
<div class="loader" *ngIf="loading_page"></div>
<app-lateral-buttons></app-lateral-buttons>
<section id="firma" class="bg-parallax firma-h-bg">
<div class="container">
  <div  class="row con-form">
    <div class="col-md-6">
      <div class="contact-h-cont">
        <h3 class="cl-white">
          Firma electrónica
        </h3>
        <div class="form-group cl-white">
            <label for="tipodocumento">Tipo documento</label>
            <select class="form-control" [(ngModel)]="selectedItem" [ngModelOptions]="{standalone: true}" (change)="getPromisesNotes()">
                <option disabled selected> Seleccione el tipo de documento</option>
                <option value="1">C.C</option>
                <option value="2">C.E</option>
                <option value="3">NIT</option>
            </select>
        </div>
        <div class="form-group cl-white">
            <label for="identificación">Identificación</label>
            <input type="text" class="form-control" placeholder="Ingresa el número de identificación" [(ngModel)]="identificationItem" [ngModelOptions]="{standalone: true}" (change)="getPromisesNotes()">
        </div>
        <div *ngIf="loading">
          Cargando Pagares...
        </div>
        <div class="form-group cl-white">
            <label for="identificación">Pagare</label>
            <select class="form-control" [(ngModel)]="pagareItem" [ngModelOptions]="{standalone: true}" placeholder="Seleccione pagare">
                <option *ngFor="let promiseNote of promiseNotes; let i = index" value="{{promiseNote.idSolicitud}}-{{promiseNote.idRolFirmante}}-{{promiseNote.idPagare}}">Pagare electrónico N° {{promiseNote.idPagare}}</option>
            </select>
            <div *ngIf="showLink">
              <i _ngcontent-ona-c16="" class="fa fa-eye"></i>
              <a  style="color: white;" target="_blank" routerLink="/virtual-pagare" >  Para visualizar el pagare dar clic aquí</a>
            </div>
        </div>
        <div class="form-group cl-white">
            <label for="codigootp">Código OTP</label>
            <input type="text"  placeholder="Ingresa el código OTP" class="form-control" [(ngModel)]="codeItem" [ngModelOptions]="{standalone: true}">
        </div>
        <div class="form-group ">
          <button class="btn btn-general btn-white btn-firma" (click)="signPromissoryNote()">Firmar</button>
          <button class="btn btn-general btn-white" (click)="clickResendCode()">Reenviar Código</button>          
        </div>
      </div>
    </div>
  </div>
</div>
</section>
<app-footer></app-footer>